import { ParcelStatus } from "@/enums";
import { SelectOptions } from "../select-options";

export interface IParcelStatus {
  id: ParcelStatus | "";
  mainText: string;
  show?: boolean;
}

export const parcelStatusOptions: IParcelStatus[] = [
  { id: "", mainText: "any" },
  {
    id: ParcelStatus.COMMON_STATUS_SHIPPED_FROM_FCOUNTRY,
    mainText: "on_the_way",
  },
  {
    id: ParcelStatus.COMMON_STATUS_READY_FOR_PICKUP,
    mainText: "ready_to_pick_up",
  },
  {
    // this is additional status
    id: ParcelStatus.COMMON_STATUS_RECEIVED_OUTSTOCK,
    mainText: "don't show",
    show: false,
  },
];

export default function ParcelStatusSelectFlow({
  onSelect,
}: {
  onSelect: (selectedValue: IParcelStatus) => void;
}) {
  return (
    <SelectOptions
      translation
      options={parcelStatusOptions.filter((option) => option.show !== false)}
      onSelect={onSelect}
      hideSearch
    />
  );
}
